export const StartStep = 0;
export const EyesStep = 1;
export const DigitalStep = 2;
export const VisualHealthStep = 3;
export const ErgonomieStep = 4;
export const ParameterStep = 5;